function selectionQuantityHandler(event) {
  var customPriceTemplate = `
<div class="product-info-price">
  <div class="price-box price-final_price" data-role="priceBox">
    <span class="special-price">
      <span class="price-container price-final_price tax weee" itemtype="http://schema.org/Offer">
        <span class="price-label">Special Price</span>
        <span data-price-amount="[[regular_price_per_item]]" data-price-type="finalPrice" class="price-wrapper ">
          <span class="price">[[special_price]]</span>
        </span>
        <meta itemprop="price" content="[[regular_price_per_item]]">
        <meta itemprop="priceCurrency" content="USD">
      </span>
    </span>
  </div>
  <span class="you-save">[[you_Save]]</span>
  <span class="old-price hide-on-grid">
      <span class="price-container price-final_price tax weee">
        <span class="price-label">Regular Price</span>
        <span data-price-amount="[[regular_price_per_item]]" data-price-type="oldPrice" class="price-wrapper " style="">
          <span class="price">[[regular_price]]</span>
        </span>
      </span>
    </span>
</div>`;
  let priceNode = document.querySelector('.price .price__regular');
  let element = event.currentTarget;
  if(element.dataset.specialPrice && element.dataset.youSave){
    customPriceTemplate = customPriceTemplate.replace('[[regular_price_per_item]]', element.dataset.regularPricePerItem)
    customPriceTemplate = customPriceTemplate.replace('[[regular_price]]', element.dataset.regularPrice)
    customPriceTemplate = customPriceTemplate.replace('[[special_price]]', element.dataset.specialPrice)
    customPriceTemplate = customPriceTemplate.replace('[[you_Save]]', element.dataset.youSave)
  }else {
    customPriceTemplate = customPriceTemplate.replace('[[regular_price_per_item]]', element.dataset.regularPricePerItem)
    customPriceTemplate = customPriceTemplate.replace('[[regular_price]]', '')
    customPriceTemplate = customPriceTemplate.replace('[[special_price]]', element.dataset.regularPrice)
    customPriceTemplate = customPriceTemplate.replace('[[you_Save]]', '')
  }
  priceNode.innerHTML = customPriceTemplate;
  let inputSellingPlan = element.parentElement.querySelector('input[name=selling_plan]')
  inputSellingPlan.checked = 'checked'
}

var optionsSelectionQuantity = document.querySelectorAll('ul.quantity.prices-tier > li.product-option > label:not([disabled])');
optionsSelectionQuantity.forEach((element) => {
  element.addEventListener('click',selectionQuantityHandler)
})
window.toggleAriaHiddenForModal = window.toggleAriaHiddenForModal || function(show, targetModal) {
  if (window.innerWidth >= 768) return;
  
  if (!targetModal) return;
  var modalWrapper = targetModal.closest('.custom-modal-wrapper') || targetModal;

  if (show) {
    targetModal.setAttribute('aria-modal', 'true');
    if (modalWrapper.parentElement !== document.body) {
      document.body.appendChild(modalWrapper);
    }
    
    Array.from(document.body.children).forEach(function(child) {
      if (child !== modalWrapper && child.tagName !== 'SCRIPT' && child.tagName !== 'STYLE' && child.tagName !== 'LINK') {
        var currentAria = child.getAttribute('aria-hidden');
        if (currentAria !== 'true') {
          child.setAttribute('data-original-aria-hidden', currentAria !== null ? currentAria : 'null');
          child.setAttribute('aria-hidden', 'true');
          child.setAttribute('inert', '');
        }
      }
    });
  } else {
    targetModal.setAttribute('aria-modal', 'false');
    var hiddenElements = document.querySelectorAll('[data-original-aria-hidden]');
    hiddenElements.forEach(function(el) {
      var originalAria = el.getAttribute('data-original-aria-hidden');
      if (originalAria === 'null') {
        el.removeAttribute('aria-hidden');
      } else {
        el.setAttribute('aria-hidden', originalAria);
      }
      el.removeAttribute('data-original-aria-hidden');
      el.removeAttribute('inert');
    });
  }
};

var showAutoDeliveryModal = document.querySelector('[js-auto-delivery-modal]');
if (showAutoDeliveryModal) {
  showAutoDeliveryModal.addEventListener('click',() => {
    var modal = document.getElementById('auto-delivery-modal');
    modal.classList.add('_show');
    window.toggleAriaHiddenForModal(true, modal);
    // Focus the close button for accessibility
    setTimeout(() => {
      var closeBtn = modal.querySelector('.custom-close-btn');
      if(closeBtn) {
        closeBtn.focus();
      }
    }, 100); // slight delay to ensure modal is rendered and DOM is stable
  });
}
var hideAutoDeliveryModal = document.querySelectorAll('.custom-modal-wrapper .action-close, .custom-modal-wrapper .modal-overlay');
hideAutoDeliveryModal.forEach((element) => {
  element.addEventListener('click',() => {
    var modal = document.getElementById('auto-delivery-modal');
    modal.classList.remove('_show');
    window.toggleAriaHiddenForModal(false, modal);
    // Return focus to the opening button for better keyboard flow
    if (showAutoDeliveryModal) showAutoDeliveryModal.focus();
  });
});

// Trap focus inside modal
var autoDeliveryModal = document.getElementById('auto-delivery-modal');
if (autoDeliveryModal) {
  autoDeliveryModal.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var closeBtn = autoDeliveryModal.querySelector('.custom-close-btn');
      if (closeBtn) closeBtn.click();
      return;
    }
    
    if (e.key !== 'Tab') return;

    var focusableElements = Array.from(autoDeliveryModal.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled])')).filter(function(el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0;
    });

    if (focusableElements.length === 0) {
      e.preventDefault();
      return;
    }

    if (focusableElements.length === 1) {
      focusableElements[0].focus();
      e.preventDefault();
      return;
    }

    var firstElement = focusableElements[0];
    var lastElement = focusableElements[focusableElements.length - 1];

    if (e.shiftKey) { // Shift + Tab
      if (document.activeElement === firstElement || document.activeElement === autoDeliveryModal) {
        lastElement.focus();
        e.preventDefault();
      }
    } else { // Tab
      if (document.activeElement === lastElement || document.activeElement === autoDeliveryModal) {
        firstElement.focus();
        e.preventDefault();
      }
    }
  });
}

const body = document.body;
var productFormID = document.querySelector( '.product-form__quantity form' );
var boxToCart = document.querySelector('.box-tocart');
var addToCartButton = document.querySelector('#product-addtocart-button');

// Later, to stop observing
// observer.disconnect();

const observerAddToCart = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    const currentScrollTop = window.scrollY || document.documentElement.scrollTop;
    const boxToCartRect = entry.boundingClientRect;
    const boxToCartY = boxToCartRect.top + window.scrollY;
    if (entry.isIntersecting) {
      // Element is in viewport
      addToCartButton.classList.remove('out-of-view');
      addToCartButton.classList.add('in-view');
      body.classList.remove('hide-gladly');
    } else {
      // Element is not in viewport
      if (currentScrollTop > boxToCartY) {
        addToCartButton.classList.remove('in-view');
        addToCartButton.classList.add('out-of-view');
        body.classList.add('hide-gladly');
      }
    }
  });
});

doit = () => {
  const fn = () => {
      if(window.innerWidth<750) {
        observerAddToCart.observe(boxToCart);
      }
      else {
        addToCartButton.classList.remove('out-of-view');
        addToCartButton.classList.remove('in-view');
        observerAddToCart.disconnect();
      }
  }
  fn()
  window.addEventListener('resize', fn)
}
doit();
















